<template>
    <div>
        <Button
            @click="show = true"
            :disabled="isDefault"
            color="light"
            size="small"
            iconName="check"
            class="w-full"
        >
            <template v-if="isDefault"> Default </template>
            <template v-else> Make default </template>
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="info"
            title="Make this availability the default?"
            actionText="Yes, make default"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    Any time a new team member joins your account he/she will
                    inherit this availability.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="urlFactory.makeAvailabilityDefaultUrl(availability.id)"
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Availability from '@/App/Availability/Entity/Availability'
    import Company from '@/App/Company/Entity/Company'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'

    const emits = defineEmits<{
        onSuccess: [{ company: Company }]
    }>()

    const props = defineProps({
        isDefault: {
            type: Boolean,
            required: true,
        },
        availability: {
            type: Object as PropType<Availability>,
            required: true,
        },
    })

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                const company = response.getHydratedCompany(
                    ResponseJsonKeyEnum.App_Company_DefaultAvailability_CompanyData,
                )

                emits('onSuccess', { company: company })
                show.value = false
            })
            ?.catch(() => {
                show.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
